import {Grid} from "@mui/material"
import React from "react"

const RaterMapeamento = () => {
    return (<Grid>
        </Grid>

    )
}

export default RaterMapeamento